import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { CallbackHandlerPage } from 'msisdk-react';
import { useNavigate } from '@alfa-retail-react/components';

import { authorizeUrlService } from 'app/logic/pages/redirect/AuthorizeUrlService';
import { DraftOrderPage } from 'app/logic/pages/draftOrder/DraftOrderPage';
import { IntroductionPage } from 'app/logic/pages/introduction/IntroductionPage';
import { OrderPage } from 'app/logic/pages/order/OrderPage';
import { ConfirmationPage } from 'app/logic/pages/confirmation/ConfirmationPage';
import { ResultPage } from 'app/logic/ResultPage';
import { ErrorPage } from 'app/logic/pages/error/ErrorPage';
import { EmploymentPage } from 'app/logic/pages/employment/EmploymentPage';
import { SmsSignPage } from 'app/logic/pages/sign/SmsSignPage';
import { RedirectPage } from 'app/logic/pages/redirect/RedirectPage';
import { ApplicationContextProvider } from 'app/store/сontext/ApplicationContext';
import { NotificationContextProvider } from 'app/store/сontext/NotificationContextProvider';
import { ScrollToTop } from 'app/ScrollToTop';
import {
    UNEXPECTED_ERROR_PAGE_URL,
    UnexpectedErrorPage,
} from 'app/logic/pages/error/UnexpectedErrorPage';
import { ProductParametersConfigurePage } from 'app/logic/pages/productParametersConfigure/ProductParametersConfigurePage';
import { ContinueDraftByLinkPage } from 'app/logic/pages/ContinueDraftByLink/ContinueDraftByLinkPage';

import { I18nContextProvider } from './store/сontext/I18nContext';
import { APP_ROUTES } from '../app-routes';

import '@alfa-retail-react/components/style/default-theme.less';
import 'app/App.less';

const PageNotFoundError = () => {
    useEffect(() => {
        window.location.href = '/404';
    }, []);

    return <div></div>;
};

function App() {
    const navigate = useNavigate();

    /**
     * Устанавливает обработчик необработанных исключений, которые возникли в асинхронных функциях.
     */
    const setUnhandledErrorsProcessing = () => {
        window.addEventListener('unhandledrejection', () => {
            navigate(UNEXPECTED_ERROR_PAGE_URL);
        });
    };

    useEffect(() => {
        setUnhandledErrorsProcessing();
    }, []);

    return (
        <ApplicationContextProvider>
            <I18nContextProvider>
                <NotificationContextProvider>
                    <ScrollToTop>
                        <Routes>
                            <Route
                                path={APP_ROUTES.PRODUCT}
                                element={<IntroductionPage />}
                            />
                            <Route
                                path={APP_ROUTES.DRAFT}
                                element={<DraftOrderPage />}
                            />
                            <Route
                                path={APP_ROUTES.ORDER}
                                element={<OrderPage />}
                            />
                            <Route
                                path={APP_ROUTES.EMPLOYMENT}
                                element={<EmploymentPage />}
                            />
                            <Route
                                path={APP_ROUTES.CONFIGURE}
                                element={<ProductParametersConfigurePage />}
                            />
                            <Route
                                path={APP_ROUTES.CONFIRMATION}
                                element={<ConfirmationPage />}
                            />
                            <Route
                                path={APP_ROUTES.SMS}
                                element={<SmsSignPage />}
                            />
                            <Route
                                path={APP_ROUTES.CONTINUE}
                                element={<ContinueDraftByLinkPage />}
                            />
                            <Route
                                path={APP_ROUTES.REDIRECT}
                                element={<RedirectPage />}
                            />
                            <Route
                                path={APP_ROUTES.RESULT}
                                element={<ResultPage />}
                            />
                            <Route
                                path={authorizeUrlService.getCallbackUrlPath()}
                                element={<CallbackHandlerPage />}
                            />
                            <Route
                                path={APP_ROUTES.ERROR}
                                element={<ErrorPage />}
                            />
                            <Route
                                path={APP_ROUTES.UNEXPECTED_ERROR}
                                element={<UnexpectedErrorPage />}
                            />
                            <Route path="/*" element={<PageNotFoundError />} />
                        </Routes>
                    </ScrollToTop>
                </NotificationContextProvider>
            </I18nContextProvider>
        </ApplicationContextProvider>
    );
}

// eslint-disable-next-line import/no-default-export
export default App;
